import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_searchComponent = _resolveComponent("searchComponent")!
  const _component_tableComponent = _resolveComponent("tableComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_searchComponent, {
      "search-list": _ctx.searchList,
      "onUpdate:searchList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchList) = $event)),
      "button-list": _ctx.buttonList,
      onDoSearch: _ctx.handleSearch
    }, null, 8, ["search-list", "button-list", "onDoSearch"]),
    _createVNode(_component_tableComponent, {
      class: "mg-t-12",
      "table-data": _ctx.tableData,
      "table-head": _ctx.tableHead,
      "row-key": "id",
      onSelectionChange: _ctx.handleSelectionChange,
      "page-info": _ctx.pageInfo,
      onSizeChange: _ctx.handleSizeChange,
      onCurrentChange: _ctx.handleCurrentChange
    }, {
      status: _withCtx((scope) => [
        _createElementVNode("div", {
          class: _normalizeClass([`icon-${scope.row.status}`])
        }, _toDisplayString(_ctx.statusMap[scope.row.status]), 3)
      ]),
      _: 1
    }, 8, ["table-data", "table-head", "onSelectionChange", "page-info", "onSizeChange", "onCurrentChange"])
  ]))
}